import api from '../../utils/api';
import { getRetailerSuppliers, getProductFilters, getProductsAll, getProducts } from './api/retailers';
import { formatMany } from '../../utils/formatHelper';
import { alertError, alertSuccess } from './alert';
import { putRetailersPermissions } from './permissions';

import { setProductFilters, setProductFiltersSetFilters } from './productFilters';

import {
  DROPSHIP_PRODUCTS,
  DROPSHIP_PRODUCTS_COUNT,
  DROPSHIP_PRODUCTS_CHECK,
  DROPSHIP_PRODUCTS_UNCHECK,
  DROPSHIP_PRODUCTS_SEARCH,
  DROPSHIP_PRODUCTS_OFFSET,
  DROPSHIP_PRODUCTS_LOADING,
  DROPSHIP_PRODUCTS_SUPPLIER_ID,
  DROPSHIP_PRODUCTS_BRANDS,
  DROPSHIP_PRODUCTS_CHECK_ALL_ON_PAGE,
  DROPSHIP_PRODUCTS_UNCHECK_ALL,
  DROPSHIP_PRODUCTS_ALL,
  DROPSHIP_PRODUCTS_PRODUCT,
  DROPSHIP_PRODUCTS_PRODUCT_LOADING,
  DROPSHIP_PRODUCTS_MODAL_CLOSE,
  DROPSHIP_PRODUCTS_MODAL_OPEN,
  DROPSHIP_PRODUCTS_APPROVED,
  DROPSHIP_PRODUCTS_DETAILS,
  DROPSHIP_PRODUCTS_MODAL_PRODUCT,
  DROPSHIP_PRODUCTS_APPROVE,
  DROPSHIP_PRODUCTS_UNAPPROVE,
  DROPSHIP_PRODUCTS_LOADING_PRODUCTS,
} from '../constants/dropshipProductsTypes';

import { ORDER_TYPE_ECOMMERCE } from '../../constants/orderTypes';
import { getTotalCountHeader } from './api/utils';

export const setDropshipProductsModalClose = { type: DROPSHIP_PRODUCTS_MODAL_CLOSE };

const setDropshipProducts = (data) => ({ type: DROPSHIP_PRODUCTS, payload: data });
const setDropshipProductsCount = (count) => ({ type: DROPSHIP_PRODUCTS_COUNT, payload: count });
const setDropshipProductsBrands = (data) => ({ type: DROPSHIP_PRODUCTS_BRANDS, payload: data });
const setDropshipProductsAll = (data) => ({ type: DROPSHIP_PRODUCTS_ALL, payload: data });
const setDropshipProductsProduct = (data) => ({ type: DROPSHIP_PRODUCTS_PRODUCT, payload: data });
const setDropshipProductsProductLoading = (value) => ({ type: DROPSHIP_PRODUCTS_PRODUCT_LOADING, payload: value });
const setDropshipProductDetails = (data) => ({ type: DROPSHIP_PRODUCTS_DETAILS, payload: data });
const setDropshipProductsModalProduct = (data) => ({ type: DROPSHIP_PRODUCTS_MODAL_PRODUCT, payload: data });

const setDropshipProductsLoading = (loadingProducts, value) => ({
  type: loadingProducts ? DROPSHIP_PRODUCTS_LOADING_PRODUCTS : DROPSHIP_PRODUCTS_LOADING,
  payload: value,
});

export const setDropshipProductsModalOpen = (product) => (dispatch) => {
  dispatch(setDropshipProductsModalProduct(product));
  dispatch(getDropshipProductsDetails(product.model));
  dispatch({ type: DROPSHIP_PRODUCTS_MODAL_OPEN });
};

export const dropshipProductsCheckAllOnPage = (ids) => ({ type: DROPSHIP_PRODUCTS_CHECK_ALL_ON_PAGE, payload: ids });

export const dropshipProductsCheckAll = () => async (dispatch, getState) => {
  const state = getState();
  const { supplierId, search } = state.dropshipProducts;
  const { retailerId } = state.role;
  const { currentFilters } = state.productFilters;

  try {
    const response = await getProductsAll(retailerId, supplierId, ORDER_TYPE_ECOMMERCE, currentFilters, search);
    dispatch(setDropshipProductsAll(response.data));
  } catch (error) {
    dispatch(alertError(error));
  }
};

export const getDropshipProductsDetails = (model) => async (dispatch, getState) => {
  try {
    dispatch(setDropshipProductDetails({}));
    const state = getState();
    const { retailerId } = state.role;
    const { supplierId } = state.dropshipProducts;

    const response = await productsDetails(retailerId, supplierId, model);

    dispatch(setDropshipProductDetails(response.data));
    dispatch(setDropshipProductsDefaultApproved());
  } catch (error) {
    dispatch(alertError(error));
  }
};

export const dropshipProductsUncheckAll = { type: DROPSHIP_PRODUCTS_UNCHECK_ALL };

export const setDropshipProductsSupplierId = (id) => (dispatch) => {
  dispatch(setDropshipProductsCurrentFilter({}));
  dispatch({ type: DROPSHIP_PRODUCTS_SUPPLIER_ID, payload: id });
  dispatch(getDropshipProducts());
  dispatch(getDropshipProductsFilters());
};

export const dropshipProductsApproveChecked = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const { checked } = state.dropshipProducts;
    const { retailerId } = state.role;

    const variants = [];

    Object.keys(checked).forEach((model) => {
      checked[model].forEach((variantId) => {
        variants.push(variantId.id || variantId);
      });
    });

    let data = [
      {
        retailer_ids: [retailerId],
        variant_ids: variants,
        approved: true,
      },
    ];

    const response = await putDropshipPermissions(data, retailerId);

    if (response.data.success) {
      dispatch(alertSuccess(`${formatMany(Object.keys(checked).length, 'product')} successfully approved`));
      dispatch(dropshipProductsUncheckAll);
      dispatch(getDropshipProducts());
    } else {
      dispatch(alertError('Error'));
    }
  } catch (error) {
    dispatch(alertError(error));
  }
};

export const dropshipProductsUnapproveChecked = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const { checked } = state.dropshipProducts;
    const { retailerId } = state.role;

    const variants = [];

    Object.keys(checked).forEach((model) => {
      checked[model].forEach((variantId) => {
        variants.push(variantId.id || variantId);
      });
    });

    const data = [
      {
        retailer_ids: [retailerId],
        variant_ids: variants,
        approved: false,
      },
    ];

    const response = await putDropshipPermissions(data, retailerId);

    if (response.data.success) {
      dispatch(alertSuccess(`${formatMany(Object.keys(checked).length, 'product')} successfully revoked`));
      dispatch(dropshipProductsUncheckAll);
      dispatch(getDropshipProducts());
    } else {
      dispatch(alertError('Error'));
    }
  } catch (error) {
    dispatch(alertError(error));
  }
};

export const dropshipProductsApprove = (variants) => (dispatch) => {
  dispatch({ type: DROPSHIP_PRODUCTS_APPROVE, payload: variants });
};

export const dropshipProductsUnapprove = (variants) => (dispatch) => {
  dispatch({ type: DROPSHIP_PRODUCTS_UNAPPROVE, payload: variants });
};

export const setDropshipProductsDefaultApproved = () => (dispatch, getState) => {
  const {
    productDetails: { variants },
  } = getState().dropshipProducts;

  const approved = variants.reduce((approved, v) => {
    if (v.ecommerce_approved_by_retailer) {
      approved.push(v.id);
    }
    return approved;
  }, []);

  dispatch({ type: DROPSHIP_PRODUCTS_APPROVED, payload: approved });
};

export const dropshipProductsCheck = (id) => async (dispatch) => {
  dispatch({ type: DROPSHIP_PRODUCTS_CHECK, payload: id });
};

export const dropshipProductsUncheck = (id) => async (dispatch) => {
  dispatch({ type: DROPSHIP_PRODUCTS_UNCHECK, payload: id });
};

export const getDropshipProductsBrands = () => (dispatch, getState) => {
  const { retailerId, retailerSuppliers } = getState().role;

  dispatch(setDropshipProductsLoading(false, true));

  Promise.resolve()
    .then(() => {
      if (!retailerSuppliers || !retailerSuppliers.length) {
        return getRetailerSuppliers(retailerId).then((response) => response?.data || []);
      } else {
        return retailerSuppliers;
      }
    })
    .then((retailerBrands) => {
      dispatch(setDropshipProductsBrands(retailerBrands));
      dispatch(getDropshipProducts(true));
      dispatch(getDropshipProductsFilters());
      dispatch(setDropshipProductsLoading(false, false));
    });
};

export const putDropshipProductsProduct = (data, model, supplierId) => async (dispatch, getState) => {
  try {
    const { retailerId } = getState().role;
    const response = await putProduct(data, retailerId, supplierId, model);

    if (response.data.success) {
      dispatch(alertSuccess('Success'));
    } else {
      dispatch(alertError('Error'));
    }
  } catch (error) {
    dispatch(alertError(error));
  }
};

export const getDropshipProductsProduct = (model, supplierId) => async (dispatch, getState) => {
  try {
    dispatch(setDropshipProductsProductLoading(true));

    const { retailerId } = getState().role;
    const response = await productsDetails(retailerId, supplierId, model);

    dispatch(setDropshipProductsProduct(response.data));
    dispatch(setDropshipProductsProductLoading(false));
  } catch (error) {
    dispatch(setDropshipProductsProductLoading(false));
    dispatch(alertError(error));
  }
};

export const getDropshipProducts =
  (loadingProducts = true) =>
  async (dispatch, getState) => {
    try {
      dispatch(setDropshipProductsLoading(loadingProducts, true));

      const state = getState();
      const { retailerId } = state.role;
      const { perPage, offset, count, search, supplierId } = state.dropshipProducts;
      const { currentFilters } = state.productFilters;

      const response = await getProducts(
        retailerId,
        supplierId,
        ORDER_TYPE_ECOMMERCE,
        currentFilters,
        offset,
        perPage,
        search,
        'asc',
        'title',
      );

      const newCount = getTotalCountHeader(response);

      if (count !== newCount) {
        dispatch(setDropshipProductsCount(newCount));
      }

      dispatch(setDropshipProducts(response.data));
      dispatch(setDropshipProductsLoading(loadingProducts, false));
    } catch (error) {
      dispatch(alertError(error));
      dispatch(setDropshipProductsLoading(loadingProducts, false));
    }
  };

export const setDropshipProductsSearch = (search) => (dispatch) => {
  dispatch({ type: DROPSHIP_PRODUCTS_SEARCH, payload: search });
  dispatch(setDropshipProductsOffset(0));
};

export const setDropshipProductsOffset = (offset) => (dispatch) => {
  dispatch({ type: DROPSHIP_PRODUCTS_OFFSET, payload: offset });
  dispatch(getDropshipProducts());
};

export const dropshipProductsSaveVariants = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const { approved, unapproved } = state.dropshipProducts;
    const { retailerId } = state.role;

    let approvedData = {
      variant_ids: approved,
      approved: true,
    };

    let unapprovedData = {
      variant_ids: unapproved,
      approved: false,
    };

    const approveResponse = await putRetailersPermissions(retailerId, [approvedData, unapprovedData]);

    if (approveResponse.data.success) {
      dispatch(alertSuccess('Success'));
      dispatch(getDropshipProducts());
    }
  } catch (error) {
    dispatch(alertError(error));
  }
};

export const getDropshipProductsFilters = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const { retailerId } = state.role;
    const { supplierId } = state.dropshipProducts;
    const response = await getProductFilters(retailerId, supplierId, ORDER_TYPE_ECOMMERCE);

    dispatch(setProductFilters(response.data));
  } catch (error) {
    dispatch(alertError(error));
  }
};

export const setDropshipProductsCurrentFilter = (filters) => (dispatch) => {
  dispatch(setProductFiltersSetFilters(filters));
  dispatch(setDropshipProductsOffset(0));
};

let cancelPutPermissions;
const putDropshipPermissions = (data, retailerId) => {
  if (cancelPutPermissions) {
    cancelPutPermissions('Cancel dropship put permissions');
  }

  return api.put(`/retailers/${retailerId}/permissions`, data, {
    cancelToken: new api.CancelToken((c) => (cancelPutPermissions = c)),
  });
};

let cancelPutProduct;
const putProduct = (data, retailerId, supplierId, model) => {
  if (cancelPutProduct) {
    cancelPutProduct('Cancel dropship put product');
  }

  model = encodeURIComponent(model);
  return api.put(`/retailers/${retailerId}/suppliers/${supplierId}/products/${model}`, data, {
    cancelToken: new api.CancelToken((c) => (cancelPutProduct = c)),
  });
};

let cancelProductsDetails;
const productsDetails = (retailerId, supplierId, model) => {
  if (cancelProductsDetails) {
    cancelProductsDetails('Cancel product details');
  }

  model = encodeURIComponent(model);
  return api.get(
    `/retailers/${retailerId}/suppliers/${supplierId}/products/${model}?service_type=${ORDER_TYPE_ECOMMERCE}`,
    {
      cancelToken: new api.CancelToken((c) => (cancelProductsDetails = c)),
    },
  );
};
